// extracted by mini-css-extract-plugin
module.exports = {"footer-item":"RenderFooter_footer-item__0lK45","footer-title":"RenderFooter_footer-title__LDVRe","icon-footer":"RenderFooter_icon-footer__Y8QN7"};